import { combineReducers } from "redux";
import { createReduxOperation } from "src/store/utils";
import * as api from "src/api/takeNotes";
import { getCharts } from "src/api/common";
import { parseJson, TimeDifferenceGA } from "src/shared/utils";
import noteData from "src/shared/models/TakeNotesModel";
import { ThunkResult } from "src/shared/types";
import { AddNotesPayload, ClearTypes, FetchNotesPayload, UpdateNotesPayload, INotesRootState } from "./types";

const {
  actions: [notesFetchRequest, notesFetchSuccess, notesFetchFailure, notesFetchClear],
  reducer: notesFetchReducer,
} = createReduxOperation("FETCH_TAKE_NOTES");

const {
  actions: [notesAddRequest, notesAddSuccess, notesAddFailure, notesAddClear],
  reducer: notesAddReducer,
} = createReduxOperation("ADD_TAKE_NOTES");

const {
  actions: [notesUpdateRequest, notesUpdateSuccess, notesUpdateFailure, notesUpdateClear],
  reducer: notesUpdateReducer,
} = createReduxOperation("UPDATE_TAKE_NOTES");

export function fetchNotes({ userDetails }: FetchNotesPayload): ThunkResult<Promise<void>> {
  return async (dispatch, getState) => {
    if (userDetails) {
      dispatch(notesFetchRequest());
      const selectedTabValue = getState().app.selectedTab;
      const { response, error } = await api.getNotes({ userDetails, selectedTabValue });
      if (response) {
        const {
          app: { selectedTab, appConfig },
        } = getState();
        const notes = noteData.createTakeNotes(response);
        dispatch(notesFetchSuccess(notes));
        const allchartData: any = noteData.prepareChartdata(notes, selectedTab, appConfig.payload);
        notes.setChartsData(allchartData);
        const { response: chartsResponse, error: chartsError } = await getCharts({
          data: JSON.stringify(allchartData),
          timeTab: selectedTab,
          shouldFetchFreshData: true,
        });
        if (chartsResponse && chartsResponse.data) {
          chartsResponse.data.forEach((curr) => {
            curr.data = parseJson(curr.data);
          });
          notes.setChartsData(chartsResponse);
          notes.setNumbers(selectedTabValue);
          dispatch(notesFetchSuccess(notes));
          if (selectedTab == "Today") {
            const currentChartsData = chartsResponse.data.filter((item) => {
              return item["time_view"] == "currentChart";
            });
            TimeDifferenceGA(currentChartsData, "Notes Page");
          }
        } else {
          dispatch(notesFetchFailure(chartsError));
        }
      } else {
        dispatch(notesFetchFailure(error));
      }
    }
  };
}

export function addNotes({ data, userDetails }: AddNotesPayload): ThunkResult<Promise<void>> {
  return async (dispatch) => {
    if (userDetails) {
      dispatch(notesAddRequest());
      const { response, error } = await api.addNotes({ data, userDetails });
      if (response) {
        dispatch(notesAddSuccess(response));
      } else {
        dispatch(notesAddFailure(error));
      }
    }
  };
}

export function updateNotes({
  data,
  userDetails,
  navigateOnSuccessfullUpdate,
}: UpdateNotesPayload): ThunkResult<Promise<void>> {
  return async (dispatch) => {
    if (userDetails) {
      dispatch(notesUpdateRequest());
      const payloadAPI = noteData.prepareAPICallData(data);
      const { response, error } = await api.updateNotes({ data: payloadAPI, userDetails });
      if (response) {
        dispatch(clearNotes());
        dispatch(notesUpdateSuccess());
        navigateOnSuccessfullUpdate();
      } else {
        dispatch(notesUpdateFailure(error));
      }
    }
  };
}

export function clearNotes(type?: ClearTypes): ThunkResult<void> {
  return (dispatch) => {
    if (type === ClearTypes.FETCH) {
      dispatch(notesFetchClear());
    } else if (type === ClearTypes.ADD) {
      dispatch(notesAddClear());
    } else if (type === ClearTypes.UPDATE) {
      dispatch(notesUpdateClear());
    } else {
      dispatch(notesFetchClear());
      dispatch(notesAddClear());
      dispatch(notesUpdateClear());
    }
  };
}

const notesReducer = combineReducers<INotesRootState>({
  fetchedNotes: notesFetchReducer,
  addedNotes: notesAddReducer,
  updatedNotes: notesUpdateReducer,
});

export default notesReducer;
